<template>
    <div class="row">
        <div class="col-md-12" style="min-height:80vh">
            <p>If you have any feedback, suggestions or comments we would love to hear from you. Bug reports are also welcome!</p>
            <p>Please email <a href="mailto:scientificedibles@protonmail.com">scientificedibles@protonmail.com</a></p>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Contact Us'
    }
}
</script>

<style>

</style>